import { TrendingDown, Trophy } from "lucide-react";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from "recharts";
import { MONTHS_ES } from "../constants";

export const PnlVsBitcoin = ({ btcData }) => {
  if (!btcData || !btcData.comparison_data || btcData.comparison_data.length === 0) {
    return (
      <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
        <h3 className="text-lg font-semibold text-white mb-4">PNL Acumulado vs Bitcoin</h3>
        <p className="text-gray-500">Cargando datos de Bitcoin...</p>
      </div>
    );
  }

  const { comparison_data, summary } = btcData;
  const beatingBtc = summary.beating_btc;

  const formatMonth = (dateStr) => {
    const [, month, day] = dateStr.split('-');
    return `${parseInt(day)} ${MONTHS_ES[parseInt(month) - 1]}`;
  };

  return (
    <div className="bg-[#0d0d0f] rounded-xl border border-gray-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white">PNL Acumulado vs Bitcoin</h3>
        <div className={`flex items-center gap-2 px-4 py-2 rounded-lg ${beatingBtc ? 'bg-emerald-500/20 border border-emerald-500/40' : 'bg-red-500/20 border border-red-500/40'}`}>
          {beatingBtc ? (
            <>
              <Trophy className="w-5 h-5 text-yellow-400" />
              <span className="text-emerald-400 font-bold">+{summary.difference_pct.toFixed(2)}% vs BTC</span>
            </>
          ) : (
            <>
              <TrendingDown className="w-5 h-5 text-red-400" />
              <span className="text-red-400 font-bold">{summary.difference_pct.toFixed(2)}% vs BTC</span>
            </>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-gray-900/50 rounded-lg p-3">
          <p className="text-gray-400 text-xs mb-1">Tu Rendimiento</p>
          <p className={`text-lg font-bold ${summary.pnl_return_pct >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
            {summary.pnl_return_pct >= 0 ? '+' : ''}{summary.pnl_return_pct}%
          </p>
        </div>
        <div className="bg-gray-900/50 rounded-lg p-3">
          <p className="text-gray-400 text-xs mb-1">Bitcoin</p>
          <p className={`text-lg font-bold ${summary.btc_return_pct !== 0 ? (summary.btc_return_pct >= 0 ? 'text-orange-400' : 'text-red-400') : 'text-gray-500'}`}>
            {summary.btc_return_pct !== 0 ? (summary.btc_return_pct >= 0 ? '+' : '') + summary.btc_return_pct + '%' : 'Cargando...'}
          </p>
        </div>
        <div className="bg-gray-900/50 rounded-lg p-3">
          <p className="text-gray-400 text-xs mb-1">BTC Inicio</p>
          <p className="text-white font-medium">${summary.initial_btc_price?.toLocaleString()}</p>
        </div>
        <div className="bg-gray-900/50 rounded-lg p-3">
          <p className="text-gray-400 text-xs mb-1">BTC Final</p>
          <p className="text-white font-medium">${summary.final_btc_price?.toLocaleString()}</p>
        </div>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={comparison_data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f1f23" />
            <XAxis dataKey="date" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 10 }} tickFormatter={formatMonth} interval="preserveStartEnd" />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 11 }} tickFormatter={(v) => `${v}%`} />
            <Tooltip content={({ active, payload, label }) => {
              if (active && payload && payload.length) {
                return (
                  <div className="bg-gray-900 border border-gray-700 rounded-lg p-3 shadow-xl">
                    <p className="text-gray-400 text-sm mb-2">{label}</p>
                    <p className="text-emerald-400 font-semibold">Tu PNL: {payload[0]?.value >= 0 ? '+' : ''}{payload[0]?.value}%</p>
                    <p className="text-orange-400 font-semibold">Bitcoin: {payload[1]?.value >= 0 ? '+' : ''}{payload[1]?.value}%</p>
                  </div>
                );
              }
              return null;
            }} />
            <Legend wrapperStyle={{ paddingTop: '20px' }} formatter={(value) => <span className="text-gray-300">{value}</span>} />
            <Line type="monotone" dataKey="pnl_pct" name="Tu Rendimiento" stroke="#10b981" strokeWidth={3} dot={false} activeDot={{ r: 6, fill: '#10b981' }} />
            <Line type="monotone" dataKey="btc_pct" name="Bitcoin" stroke="#f97316" strokeWidth={3} dot={false} activeDot={{ r: 6, fill: '#f97316' }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
